<template>
  <cs-app>
    <template v-slot:content>
      <md-card>
        <div class="container">
          <md-card-header>
            <div class="md-title">Oops! Something went wrong :(</div>
          </md-card-header>

          <md-card-content>
            Something went wrong with your form submission. There are a few things that could have happened:
            <ul>
              <li>We thought you were a bot.</li>
              <li>You've submitted a case already and we don't allow multiple case submissions.</li>
              <li>You navigated to this page without submitting a case.</li>
            </ul>
          </md-card-content>
        </div>
      </md-card>
    </template>
  </cs-app>
</template>

<script>

import CSApp from '@/components/CSApp'

export default {
  name: 'ErrorOnFormSubmission',
  components: {
    'cs-app': CSApp,
  }
}

</script>